import styled from 'styled-components'
import 'typeface-quattrocento-sans'

const SubTitle = styled.h3`
  font-family: 'Quattrocento Sans', sans-serif;
  font-size: 2rem;
  color: #202020;
  @media (max-width: 991.98px) { }
  @media (max-width: 767.98px) { font-size: 1rem; }
  @media (max-width: 575.98px) { }
`

export default SubTitle



// WEBPACK FOOTER //
// ./src/components/sub-title.js